import { getPublicAssetUrl } from './api.js';

const DEFAULT_NEWS_COVER = '/images/news-img1.jpg';

export function extractNewsYear(date = '') {
  const match = String(date).match(/(20\d{2}|19\d{2})/);

  return match ? match[1] : '';
}

export function getNewsYear(newsItem = {}) {
  return String(newsItem.year || extractNewsYear(newsItem.date) || '');
}

export function getNewsCover(newsItem = {}) {
  return getNewsImageUrl(newsItem.cover || newsItem.images?.[0] || DEFAULT_NEWS_COVER);
}

export function getNewsImageUrl(imagePath = '') {
  if (!imagePath) {
    return DEFAULT_NEWS_COVER;
  }

  return getPublicAssetUrl(imagePath);
}

export function getNewsPreview(newsItem = {}) {
  const firstParagraph = newsItem.text?.find((paragraph) => paragraph?.trim());

  return firstParagraph || 'Подробности доступны на странице материала.';
}
